export const aboutData = {
  title: "About Me",
  description1: "My name is Suman Saurav.",
  description2:
    "I am a Full Stack Developer with experience in MERN specializes in building full-stack web applications using the MERN stack, which includes MongoDB, Express.js, React.js, and Node.js. With a focus on React, I am skilled in creating dynamic, responsive, and user-friendly front-end interfaces.",
  image: 
    "https://i.postimg.cc/v85gghLm/about2.jpg",
};
